var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 77,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m75.451 38.185 23.547-6.727v30.593a5.512 5.512 0 0 1-4.16 5.328l-37.193 9.299c-1.75.43-3.578.43-5.328 0l-37.151-9.299a5.483 5.483 0 0 1-4.167-5.328V31.458l23.547 6.738c.742.22 1.512.33 2.286.326a8.36 8.36 0 0 0 7.132-4.039L55 16.162 66.05 34.483a8.331 8.331 0 0 0 7.115 4.022 7.904 7.904 0 0 0 2.286-.32Z",
    fill: "#ffe322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m109.712 19.228-8.851-17.675a2.807 2.807 0 0 0-2.87-1.53L54.999 5.506l15.76 26.141a2.826 2.826 0 0 0 3.18 1.255l34.013-9.71a2.83 2.83 0 0 0 1.76-3.964ZM9.15 1.553.299 19.228a2.801 2.801 0 0 0 1.736 3.953l34.013 9.71a2.827 2.827 0 0 0 3.18-1.254l15.77-26.131L12.004.03A2.808 2.808 0 0 0 9.15 1.553Z",
    fill: "#ffe322"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 89,
    height: 61
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m75.451 38.185 23.547-6.727v30.593a5.512 5.512 0 0 1-4.16 5.328l-37.193 9.299c-1.75.43-3.578.43-5.328 0l-37.151-9.299a5.483 5.483 0 0 1-4.167-5.328V31.458l23.547 6.738c.742.22 1.512.33 2.286.326a8.36 8.36 0 0 0 7.132-4.039L55 16.162 66.05 34.483a8.331 8.331 0 0 0 7.115 4.022 7.904 7.904 0 0 0 2.286-.32Z",
    fill: "#ffe322"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M54.09 15.098h1.502V78.46l-.751.05-.752-.05V15.098Z",
    fill: "#ffe322"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.fc7125ed7219ae1f6a2d9056e30e68e8.svg";
export { ForwardRef as ReactComponent };